var map = {
	"./ALSi6-AED.png": "ff9c",
	"./ALSi6-Defib.png": "78b0",
	"./ALSi6-Monitor.png": "f03c",
	"./ALSi6-Numerics.png": "fbef",
	"./ALSi6-Wave.png": "5e77",
	"./CTGi.png": "61d1",
	"./corpuls_aed.png": "77b4",
	"./corpuls_corpuls1.png": "63f8",
	"./corpuls_corpuls3-4th-gen.png": "96b7",
	"./corpuls_corpuls3.png": "21fee",
	"./ge_carescape.png": "f663",
	"./generic-ventilator.png": "edf9",
	"./lifepak-15.png": "2ee4",
	"./lifepak-20.png": "60aaa",
	"./lifepak_AED1000.png": "67ab",
	"./medtronic_bis.png": "69e5",
	"./medtronic_capnostream-35.png": "5bdb",
	"./medtronic_invos.png": "9917",
	"./nihon-kohden_TEC5600.png": "d9b2",
	"./nihon-kohden_TEC8300.png": "01a1",
	"./philips_heartstart-MRx-black.png": "a44c",
	"./philips_heartstart-MRx-white.png": "8e53",
	"./philips_mx800.png": "9477",
	"./propaq_md.png": "b52f",
	"./revel-ptv.png": "d78a",
	"./schiller-defigard-touch-7.png": "d1c4",
	"./schiller-physiogard-touch-7.png": "3c57",
	"./tempus-ls.png": "1ff9",
	"./tempus-pro.png": "9cb1",
	"./wac_vital-signs.png": "b749",
	"./zoll-emv.png": "8f74",
	"./zoll-r-series.png": "6f7d",
	"./zoll-x-series.jpg": "1a4f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0f69";